import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [scrolled, setScrolled]   = useState(false);
  const [menuOpen, setMenuOpen]   = useState(false);
  const navigate  = useNavigate();
  const location  = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close menu on route change
  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  // Prevent body scroll when menu open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const goTo = (path) => {
    navigate(path);
    setMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const isActive = (path) => location.pathname === path;
  const isHome   = location.pathname === '/';

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${isHome ? 'light-hero' : 'dark-hero'}`}>
      <div className="navbar-inner">

        {/* Logo */}
        <div className="nav-logo" onClick={() => goTo('/')}>
          <img src="/logo.png" alt="Naik Neuro Clinic" className="nav-logo-img" />
          <span className="nav-logo-text">
            Naik Neuro & <span className="nav-logo-accent">Skin Clinic</span>
          </span>
        </div>

        {/* Links */}
        <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
          {/* Close button inside menu — mobile only */}
          {/* <button className="nav-close-btn" onClick={() => setMenuOpen(false)} aria-label="Close menu">
            
          </button> */}

          {[
            { path: '/',             label: 'Home' },
            { path: '/about',        label: 'About' },
            { path: '/services',     label: 'Services' },
            { path: '/testimonials', label: 'Testimonials' },
            { path: '/contact',      label: 'Contact' },
          ].map(({ path, label }) => (
            <li key={path}>
              <button
                onClick={() => goTo(path)}
                className={`nav-link-btn ${isActive(path) ? 'active' : ''}`}
              >
                {label}
              </button>
            </li>
          ))}
          <li>
            <button className="nav-appt-btn" onClick={() => goTo('/contact')}>
              Book Appointment
            </button>
          </li>
        </ul>

        {/* Hamburger — shows on mobile */}
        <button
          className={`hamburger ${menuOpen ? 'hamburger-open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
